export default "__VITE_ASSET__CX5cGWs2__"